module.exports = __webpack_public_path__ + "static/media/yakuza-cover.8331c3e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Yakuza/yakuza-cover.jpg
// module id = 110
// module chunks = 51